import SpeakButton from "@/components/SpeakButton";
import { useT } from "@/i18n";
import { RECIPE, GAME_TEXT } from "@/components/games/content";

export default function ScratchRecipe() {
  const { lang } = useT();
  const tx = GAME_TEXT[lang];
  return (
    <div>
      <div className="flex flex-wrap items-center gap-2"><h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.recipe}</h3><SpeakButton compact mascot="spark" text={tx.recipe} testId="ask-games-recipe" /></div>
      <ol className="mt-4 space-y-3">
        {RECIPE.map((r, i) => (
          <li key={i} className="bg-white rounded-3xl p-4 shadow-md flex gap-4" data-testid={`recipe-step-${i}`}>
            <span className="shrink-0 w-10 h-10 rounded-full bg-orange-400 text-white font-fredoka font-bold text-lg flex items-center justify-center">{i + 1}</span>
            <div className="flex-1">
              <p className="font-semibold text-blue-950">{r[lang]}</p>
              {r.blocks.length > 0 && (
                <div className="mt-2 space-y-1">
                  {r.blocks.map(([color, es, en], j) => (
                    <div key={j} className={`${color} rounded-lg px-3 py-1.5 text-white text-sm font-bold inline-block mr-2`} style={{ marginLeft: j ? 12 : 0 }}>
                      {lang === "es" ? es : en}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
